export const createStyles = (theme: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    minWidth: 0,
    width: '100%',
  },
  controls: {
    alignItems: { xs: 'flex-start', md: 'center' },
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    minWidth: 0,
    width: '100%',
  },
  filterControl: {
    flex: '0 0 auto',
    maxWidth: '100%',
    minWidth: 0,
    width: { xs: '220px', sm: '240px' },
    '& .MuiFormHelperText-root': { display: 'none' },
  },
  searchWrapper: {
    flex: { xs: '0 0 auto', md: '0 1 320px' },
    marginLeft: { xs: 0, md: 'auto' },
    maxWidth: { xs: '100%', md: '320px' },
    minWidth: 0,
    position: 'relative',
    width: '100%',
  },
  searchInput: {
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    boxSizing: 'border-box',
    gap: theme.spacing(1),
    height: '40px',
    px: theme.spacing(1.5),
    width: '100%',
    '&:hover': { borderColor: 'text.primary' },
    '&:focus-within': { borderColor: 'primary.main' },
    '& .MuiInputBase-input': {
      color: 'text.primary',
      paddingRight: theme.spacing(4),
    },
  },
  clearButton: {
    position: 'absolute',
    right: theme.spacing(0.75),
    top: '50%',
    transform: 'translateY(-50%)',
  },
  noResults: {
    backgroundColor: 'background.paper',
    color: 'text.primary',
    p: theme.spacing(3),
    width: '100%',
  },
});
